import React from "react";
import styles from "./HomePage.module.css";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { RouterPrivateName } from "shared/RouterPrivateName";
import history from "core/helper/Helper";

function HomePage(props) {
  return (
    <div className={styles.container}>
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button
          variant="outlined"
          className={styles.btn_item}
          onClick={() => history.push(RouterPrivateName.Product.List.url)}
        >
          Items
        </Button>

        <Button
          variant="outlined"
          className={styles.btn_item}
          onClick={() => history.push(RouterPrivateName.Category.List.url)}
        >
          Categories
        </Button>
        <Button
          variant="outlined"
          className={styles.btn_item}
          onClick={() => history.push(RouterPrivateName.Sale.List.url)}
        >
          Sales
        </Button>
        <Button
          variant="outlined"
          className={styles.btn_item}
          onClick={() => history.push(RouterPrivateName.Cart.List.url)}
        >
          Carts
        </Button>
      </ButtonGroup>
    </div>
  );
}

HomePage.propTypes = {};

export default HomePage;
